import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import Math from "exact-math";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ExcelServicesService } from "../../../services/excel.service"
import { StorageService } from "../../../services/storage.service";
import { CommonService } from "src/app/services/common.service";

interface dropdata {
  value: string;
  viewValue: string;
}
interface user_access_type {
  value: string;
  viewValue: string;
}
@Component({
  selector: "app-report-login",
  templateUrl: "./report-login.component.html",
  styleUrls: ["./report-login.component.css"],
})
export class ReportLoginComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  total_count = 0;
  video: any;
  vid: any;
  maxDate = new Date();
  is_active: any;
  getVideo: any;
  videoList: any[] = [];
  searchForm: FormGroup;
  uivideoList: any;
  excelVideoList: any[];
  department_id: any;
  filter_from: any;
  filter_end: any;
  prolength: number = 0;
  form: FormGroup;
  batch_id: string;
  video_message: string;
  filter: any;
  department: any;
  dept: any;
  class: any;
  batch: any;
  dropdatas:  dropdata[] = [
    { value: "1", viewValue: "Professor" },
    { value: "2", viewValue: "Learner" },
  ];
  user_access_type: user_access_type[] = [
    { value: "1", viewValue: "Accessed Users" },
    { value: "2", viewValue: "Non accessed Users" },
  ];
  total: number;
  batchData1: any;
  studentflag: boolean;
  professorflag: boolean;
  reportrole: any;
  course: Object;
  courseData: any;
  mobile_number: string;
  username: string;
  first_name: any;
  last_name: any;
  email_address: any;
  course_id: any;
  user_type: string;
  modal: boolean = false;
  required: boolean;
  recrange: any;
  dropbox: any[];
  check: any;
  filtervalues: boolean;
  chiparray = [];
  countvalue: number = 0;
  offset: number = 1;
  limit: number = 10;
  pagedItems: any[];
  p: number;
  htmlpageshow: boolean;
  pageshow: boolean = true;
  page_count: any[];
  hod: any;
  sessionData: any;
  minDate: Date;
  findedVal: any;
  page_size: number = 10;
  filteredUserType: any;
  role: number;
  professor_id: any;
  professorname: Object;
  professorData: any;
  user_type1: string;
  user_access_report1: any;
  user_access_report: string;
  non_accessed_students: number;
  access_control: number;

  constructor(
    private storageService: StorageService,
    private datepipe: DatePipe,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private ExcelServicesService: ExcelServicesService,
    public commonService: CommonService
  ) {
    this.role = this.storageService.getRole();
    this.hod = this.storageService.getHod();
  }
  async ngOnInit() {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.searchForm = this.fb.group({
      id: [""],
      user: ["", [Validators.required]],
      user_access_type: ["", [Validators.required]],
      date: ["", [Validators.required]],
      fname: [""],
      lname: [""],
      uname: [""],
      email: [""],
      mobile: [""],
      depname: [null],
      coursename: [""],
      batchname: [""],
      session: [""],
      proname: [""],
    });
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].setValue(
        this.department_id
      );     
      this.searchForm.controls["depname"].disable();
    }

    if (this.storageService.getRole() == 4 && this.hod !== 1) {
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].setValue(this.professor_id);
      this.searchForm.controls["proname"].disable();
    }
    this.modo({ source: { value: "1" } });
    this.getDepartment();
    this.getProfessor();
    this.getCourse();
    this.getBatch();
    this.getSession();
    //this.getVideoDetails();
  }
  async getPage(page: number) {
    this.offset = page;
    await this.getVideoDetails();
    const res = await this.serverCall(this.videoList, page);
    this.total = this.countvalue;
    this.p = page;

    this.pagedItems = res;
  }
  async serverCall(sample: any[], page: number) {
    const perPage = this.limit;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  get forms() {
    return this.searchForm.controls;
  }
  getvalue(event: any, rec: any, offset: number) {
    this.spinner.show();
    this.recrange = rec;
    this.offset = offset;
    this.exportAsXLSX();
  }
  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      offset = 0,
      tempcount = 1000,
      c1,
      c2;
    this.check = Math.ceil(this.countvalue / count);
    var cvar = 1;
    for (let i = 1; i <= this.check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2, offset: offset });
      offset = offset + 1000;
    }
  }
  async modo(value: any) {
    this.filteredUserType = value.source.value;
    if (value.source.value == "1") {
      this.studentflag = true;
      this.professorflag = false;
      this.user_type1 = "Professor";
      this.reportrole = 4;
    } else {
      this.professorflag = true;
      this.studentflag = false;
      this.user_type1 = "Learner";
      this.reportrole = 5;
    }
    this.searchForm.controls["user"].setValue(value.source.value);
  }
  async useraccesstype(event: any) {
    if (event.source.value == "1") {
      this.user_access_report = "Accessed Users";
      this.non_accessed_students = 0;
    } else {
      this.user_access_report = "Non Accessed Users";
      this.non_accessed_students = 1;
    }

  }
  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }
  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );
    this.modo({source: {value: 1}});
    this.user_type = this.dropdatas[0]?.value;
    this.useraccesstype({ source: { value: 1 } });
    this.user_access_report1 = this.user_access_type[0]?.value;
    this.professorData = this.professorname["content"];
    if (this.storageService.getRole() == 4 && this.hod !== 1) {
      this.professor_id = this.storageService.getProfessor();
    }
    this.spinner.hide();
  }

  async getSession() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    );
    this.onSessionChangeEvent(true);
    this.Filter(
      this.first_name,
      this.last_name,
      this.username,
      this.email_address,
      this.mobile_number,
      this.department_id,
      this.batch_id,
      this.course_id,
      this.professor_id
    );
    this.spinner.hide();
  }

  onSessionChangeEvent(isInitLoad?) {
    // this.forms["date"].setValue(null);
    // this.getFilterDate(null);
    let sessionVal = this.forms["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        let splitedChipArray = null;
        if (this.chiparray.length) {
          this.chiparray.forEach((elem) => {
            if (elem.split(" : ")[0] === "Date") {
              splitedChipArray = elem.split(" : ")[1].split(" - ");
            }
          });
        }
        if (splitedChipArray?.length) {
          const convertedDates = splitedChipArray.map(dateStr => new Date(dateStr));
          this.forms["date"].setValue(convertedDates);
          this.getFilterDate(convertedDates);
        } else {
          this.forms["date"].setValue([new Date(), new Date()]);
          this.getFilterDate([new Date(), new Date()]);
        }
      }
    } else {
      this.forms["date"].setValue(null);
      this.getFilterDate(null);
    }
  }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;

      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
            new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
        this.searchForm.controls["date"].setValue("");    
      }
    }
  }

  async getCourse() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.course = await this.globalService.get(
      "course/list/dropdown",
      filter,
      true
    );

    this.courseData = this.course["content"];
    this.spinner.hide();
  }

  async getBatch() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData1 = this.batch["content"];
    this.spinner.hide();
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(
      dateValue,
      timeValue,
      isDateRequested
    );
  }

  async getVideoDetails() {
    if (this.offset === 1) {
      this.videoList = [];
    }
    this.required = true;
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      startdate: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      enddate: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      department_id: this.department_id,
      batch_id: this.batch_id,
      course_id: this.course_id,
      report_role: this.reportrole,
      first_name: this.first_name,
      professor_id: this.professor_id,
      last_name: this.last_name,
      username: this.username,
      email_address: this.email_address,
      mobile_number: this.mobile_number,
      non_login_users: this.non_accessed_students,
      page: this.offset,
      page_size: this.limit,
      session_id: this.findedVal?.id,
    };
    const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));

    if (!dateKeyExists) {
      this.chiparray.push("Date :" + " " + filter.startdate + " - " + filter.enddate);
    }
  
    this.getVideo = await this.globalService.get(
      "user/app/usage/report",
      filter
    );
    
    this.videoList = this.getVideo["content"]["rows"];

    this.prolength = this.videoList.length;
    if (this.non_accessed_students) {
      this.access_control = 1;
    }
    else{
      this.access_control =0;
    }
    if (this.getVideo["status"] === 200) {
      this.videoList = this.getVideo["content"]["rows"];
      this.countvalue = this.getVideo["content"]["count"];
      this.total_count = this.videoList.length;
      if (this.pageshow === true) {
        this.page_count = [];

        let page_count = Math.ceil(this.countvalue / this.limit);

        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
        this.spinner.hide();
      }
    } else {
      this.spinner.hide();
    }
    this.spinner.hide();
    this.dropboxdown();
  }

  async exportAsXLSX(): Promise<void> {
    this.spinner.show();

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      startdate: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      enddate: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      role_id: this.storageService.getRole(),
      department_id: this.department_id,
      batch_id: this.batch_id,
      report_role: this.reportrole,
      professor_id: this.professor_id,
      first_name: this.first_name,
      last_name: this.last_name,
      username: this.username,
      email_address: this.email_address,
      non_login_users: this.non_accessed_students,
      page: this.offset ? this.offset : 0,
      page_size: this.countvalue == 1000 ? 0 : 1000,
      mobile_number: this.mobile_number,
      session_id: this.findedVal?.id,
    };
    this.getVideo = await this.globalService.get(
      "user/app/usage/report",
      filter
    );

    this.excelVideoList = this.getVideo["content"]["rows"];
    if (this.excelVideoList && this.getVideo["status"] == 200 && this.non_accessed_students) {
    this.uivideoList = this.excelVideoList.map((item: any) => {

      const baseData= {
        NAME: item.first_name + " " + item.last_name,
        USER_NAME: item.username,
        USER_EMAIL_ADDRESS: item.email_address,
        USER_MOBILE_NUMBER: item.mobile_number,
      };
      return baseData;
    });
    }
    else{
      this.uivideoList = this.excelVideoList.map((item: any) => {

        const baseData= {
          NAME: item.user_details.first_name + " " + item.user_details.last_name,
          USER_NAME: item.user_details.username,
          USER_EMAIL_ADDRESS: item.user_details.email_address,
          USER_MOBILE_NUMBER: item.user_details.mobile_number,
          LOGGEDIN_AT:item.login_at?this.datepipe.transform(item.login_at,"yyyy-MM-dd HH:mm:ss"):""
        };
        return baseData;
      });
    }
    this.ExcelServicesService.exportAsExcelFile(
      this.uivideoList,
      "Login report" + " " + [this.recrange]
    );
    this.offset = 1;
    this.recrange = " ";

    this.spinner.hide();
  }

  openScrollableContent(longContent) {
    //this.findedVal = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
      // this.searchForm.reset();
    }
    // this.searchForm.reset();
    if (this.filteredUserType) {
      this.searchForm.controls["user"].setValue(this.filteredUserType);
    }
    if(!this.forms["session"].value){
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );}
    this.onSessionChangeEvent(true);
    if (this.storageService.getRole() === 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    if (this.storageService.getRole() === 4 && this.hod !== 1) {
        this.professor_id = this.storageService.getProfessor();
        this.searchForm.controls["proname"].setValue(this.professor_id);
        this.searchForm.controls["proname"].disable();
      }
  }
  
  loadMore(index) {
    this.pageshow = true;
    this.offset = index;
    this.getVideoDetails();
  }
  previous() {
    this.pageshow = true;
    this.offset = this.offset - 1;
    this.getVideoDetails();
  }
  next() {
    this.pageshow = true;
    this.offset = this.offset + 1;
    this.getVideoDetails();
  }

  Filter(
    first_name,
    last_name,
    username,
    email_address,
    mobile_number,
    department_id,
    batch_id,
    course_id,
    professor_id
  ) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
  
    if (this.user_type1 != undefined && this.user_type1 != "") {
      this.chiparray.push("User type: " + this.user_type1);
    }

    if (this.professor_id != undefined && this.professor_id != "") {
      var proffessor = this.professorData.filter(
        (x) => x.id == this.professor_id
      );
      this.chiparray.push(
        "Proff:" +
          " " +
          proffessor[0].first_name +
          " " +
          proffessor[0].last_name
      );
    }

    if (this.first_name != undefined && this.first_name != "") {
      this.chiparray.push("Fname :" + " " + this.first_name);
    }

    if (this.last_name != undefined && this.last_name != "") {
      this.chiparray.push("Lname :" + " " + this.last_name);
    }
    if (this.username != undefined && this.username != "") {
      this.chiparray.push("Uname :" + " " + this.username);
    }
    if (this.email_address != undefined && this.email_address != "") {
      this.chiparray.push("Email :" + " " + this.email_address);
    }
    if (this.mobile_number != undefined && this.mobile_number != "") {
      this.chiparray.push("Mobile :" + " " + this.mobile_number);
    }

    if (this.course_id != undefined && this.course_id != "") {
      var course = this.courseData.filter((x) => x.id == this.course_id);
      this.chiparray.push("Course:" + " " + course[0].name);
    }
    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData1.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }

    this.required = true;
    this.first_name = first_name;
    this.last_name = last_name;
    this.username = username;
    this.email_address = email_address;
    this.mobile_number = mobile_number;
    this.department_id = department_id;

    this.batch_id = batch_id;
    this.course_id = course_id;
    //this.professor_id = professor_id;
    this.pageshow = true;
    this.offset = 1;
    this.getVideoDetails();
    this.modal = true;
  }

  res() {
    // this.findedVal = null;
    this.filtervalues = false;
    this.chiparray = [];
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData?.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    ) || null;
    this.chiparray.push(
      "Session : " + this.searchForm.controls["session"]?.value
    );
    this.chiparray.push("User type: " + this.dropdatas[0]?.viewValue);
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
      this.professor_id = null;
    }
      if (this.storageService.getRole() == 4 && this.hod != 1) {
      var proff = this.professorData.filter((x) => x.id == this.professor_id);
      this.department_id = null;
      this.chiparray.push("Proff:" + " " + proff[0].first_name + " " + proff[0].last_name);
      }
    if (this.storageService.getRole() != 4) {
      this.professor_id = null;
      this.department_id = null;
    }
    this.first_name = null;
    (this.video_message = null), (this.last_name = null);
    this.email_address = null;
    this.mobile_number = null;
    this.filteredUserType = null;
    this.username = null;
    this.batch_id = null;
    this.course_id = null;
    this.filter_from = null;
    this.filter_end = null;
    this.required = false;
    this.videoList = [];
    this.searchForm.reset();
    this.prolength = 0;
    this.countvalue = 0;
    this.htmlpageshow = false;
    this.offset = 1;
    this.getVideoDetails();
  }
  paginationCount(value) {
      this.offset= 1;
    if (value >= 5) {
      this.limit = value;
    }
    this.getVideoDetails();
  }
}
